module.exports = __webpack_public_path__ + "img/bring-solutions-dark.0728e916.svg";